module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8023.3c44b55a.png";